import Vue from 'vue'
import { USER_INFO } from '@/store/mutation-types'
import { postVideoRecords } from '@/api/api'
import { Toast } from 'vant'

export function hadnleUpdateVideo (currentVideo) {
  const userInfo = Vue.ls.get(USER_INFO) ? Vue.ls.get(USER_INFO) : {}
  if (currentVideo.learningStatus === '1') return
  currentVideo.learningStatus = currentVideo.updateVideoStatus === '1' ? '1' : '2'
  const params = {
    iepUserId: userInfo.id,
    courseId: currentVideo.courseId,
    courseSectionId: currentVideo.id,
    learningStatus: currentVideo.learningStatus
  }
  postVideoRecords(params).then().catch(() => {
    Toast('视频观看状态改变错误')
  })
}

export default {
  hadnleUpdateVideo
}



// WEBPACK FOOTER //
// ./src/views/course/components/common.js